"use client";

import Link from "next/link";
import { Eye } from "lucide-react";

const PhotoCard = ({ photo }) => {
    return (
        <Link href={`/gallery/${photo.slug}`}>
            <div
                className="group cursor-pointer overflow-hidden transition-all duration-200 hover:opacity-80 relative w-full"
                style={{
                    aspectRatio: '1/1'
                }}
            >
            {/* Feature Image - Square */}
            {photo.featuredImage && (
                <img
                    src={photo.featuredImage}
                    alt={photo.title}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                        e.target.style.display = "none";
                    }}
                />
            )}

            {/* Simple overlay on hover */}
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-200 flex items-center justify-center">
                <div className="opacity-0 group-hover:opacity-80 transition-opacity duration-200">
                    <div className="bg-white/90 rounded-full p-2">
                        <Eye className="w-4 h-4 text-gray-800" />
                    </div>
                </div>
            </div>
        </div>
        </Link>
    );
};

export default PhotoCard;
